import { apiLink } from '../../constants/env';
import axiosInstance from '../AxiosInstance';

const apiLinhaProducao = {
    fetchApi: async (page) => {
        const URL = `${apiLink()}api/linha-producao?page=` + page;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();
            })
    },
    getById: async (id) => {
        const URL = `${apiLink()}api/linha-producao/` + id;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();
            })
    },
    postApi: async (arComprimido) => {
        const URL = `${apiLink()}api/linha-producao`;
        return await axiosInstance.post(URL, arComprimido)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();
            })
    },
    deleteApi: async (id) => {
        const URL = `${apiLink()}api/linha-producao/status/${id}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    putApi: async (id, arComprimido) => {
        const URL = `${apiLink()}api/linha-producao/${id}`;
        return await axiosInstance.put(URL, arComprimido)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    getByRegimeId: async (id) => {
        const URL = `${apiLink()}api/linha-producao/regime/${id}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar dados do arComprimido:', error);
                throw new Error();
            })
    },
    getByUnidadeId: async (id) => {
        const URL = `${apiLink()}api/linha-producao/all`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar dados do arComprimido:', error);
                throw new Error();
            })
    },
    getEquipamentoComUltimasLeituras: async (equipamentoId, numLeituras) => {
        const URL = `${apiLink()}api/linha-producao/${equipamentoId}/numero-leituras/${numLeituras}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar arComprimido:', error);
                throw new Error('Erro ao pegar arComprimido:', error);
            })
    },
    getarComprimidosTuneis: async (unidadeId) => {
        const URL = `${apiLink()}api/linha-producao/tuneis`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar arComprimido:', error);
                throw new Error('Erro ao pegar arComprimido:', error);
            })
    }
}

export default apiLinhaProducao; 